import { CommandMenuQueryNode } from '#pplx/frontend/composer-sdk/lexical/nodes/CommandMenuQueryNode.js';
import { $applyNodeReplacement } from 'lexical';
export function $createCommandMenuQueryNode({ placeholderText, queryStartOffset, showPlaceholder, source, }) {
    return $applyNodeReplacement(new CommandMenuQueryNode(source, placeholderText, queryStartOffset, showPlaceholder));
}
export function $isCommandMenuQueryNode(node) {
    return node instanceof CommandMenuQueryNode;
}
//# sourceMappingURL=CommandMenuQueryNodeSupport.js.map